import { palette } from '../../../styles/variables'
import { MIXPANEL_PROPS } from '../../mixpanel'

export const promotionLabel = {
  text: 'holiday_offer',
  background: '#F13D56',
  color: palette.white,
  purchaseButtonLocation:
    MIXPANEL_PROPS?.PURCHASE_BUTTON_LOCATION?.values?.HOLIDAY_UBS_BANNER,
}
